import React, { useState, useEffect } from 'react';
import * as api from '../../../api';
import * as crypto from '../../../crypto';

export default function DecryptedGsnImage({ attachmentJson }) {
  const [imgUrl, setImgUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
    let active = true;
    let createdUrl = "";
    const load = async () => {
      try {
        const att = JSON.parse(attachmentJson);
        const blob = await api.downloadFileAttachment(att.fileId);
        const decrypted = await crypto.decryptFileSymmetric(blob, att.keyHex, att.ivHex);
        if (active) {
          createdUrl = URL.createObjectURL(decrypted);
          setImgUrl(createdUrl);
          setLoading(false);
        }
      } catch (err) {
        console.error("Failed to decrypt GSN image:", err);
        if (active) {
          if (err.message === 'File expired or deleted') {
            setIsExpired(true);
          } else {
            setError(true);
          }
          setLoading(false);
        }
      }
    };
    load();
    return () => {
      active = false;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [attachmentJson]);

  if (loading) {
    return (
      <div className="gsn-img-placeholder" style={{ padding: '20px', background: 'rgba(255,255,255,0.03)', borderRadius: '8px', textAlign: 'center', fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
        ⏳ Bild wird entschlüsselt...
      </div>
    );
  }
  if (isExpired) {
    return (
      <div style={{ color: 'var(--text-muted)', fontSize: '0.8rem', padding: '8px', background: 'rgba(255,255,255,0.02)', borderRadius: '6px', border: '1px dashed var(--border-color)', display: 'inline-block', marginTop: '8px' }}>
        ⏱️ Bild nach automatischer Aufbewahrungsfrist abgelaufen.
      </div>
    );
  }
  if (error) {
    return <div style={{ color: 'var(--danger)', fontSize: '0.8rem', padding: '8px' }}>⚠️ Bild konnte nicht entschlüsselt werden.</div>;
  }

  return (
    <>
      <img
        src={imgUrl}
        alt="GSN Beitrag"
        className="gsn-post-img"
        style={{ cursor: 'zoom-in', maxWidth: '100%', borderRadius: '8px', marginTop: '8px' }}
        onClick={() => setIsZoomed(true)}
      />
      {isZoomed && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            zIndex: 99999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'zoom-out'
          }}
          onClick={() => setIsZoomed(false)}
        >
          <img
            src={imgUrl}
            alt="GSN Beitrag vergrößert"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              objectFit: 'contain'
            }}
          />
        </div>
      )}
    </>
  );
}
